import { API_ENDPOINT } from "./endpoints";

export const EMAIL_PREVIEW = (emailId) => `${API_ENDPOINT}email/${emailId}`;
